// extracted by mini-css-extract-plugin
module.exports = {"video-with-caption":"styles_video-with-caption__3sx4_","iframeContainer":"styles_iframeContainer__3jxv-"};